import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { Play, Pause } from 'lucide-react';
// Static waveform bar heights
const BARS = [6, 12, 8, 16, 10, 14, 6, 12, 18, 8, 14, 10, 16, 6, 12, 8];
export function AudioPlayer({ src, duration }) {
    const audioRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        const audio = audioRef.current;
        if (!audio)
            return;
        const onTimeUpdate = () => {
            if (audio.duration)
                setProgress(audio.currentTime / audio.duration);
        };
        const onEnded = () => {
            setPlaying(false);
            setProgress(0);
        };
        audio.addEventListener('timeupdate', onTimeUpdate);
        audio.addEventListener('ended', onEnded);
        return () => {
            audio.removeEventListener('timeupdate', onTimeUpdate);
            audio.removeEventListener('ended', onEnded);
        };
    }, []);
    const toggle = () => {
        const audio = audioRef.current;
        if (!audio)
            return;
        if (playing) {
            audio.pause();
        }
        else {
            audio.play().catch(() => { });
        }
        setPlaying(!playing);
    };
    const durationLabel = duration ? `${duration}с` : '';
    return (_jsxs("div", { className: "w-full flex items-center gap-3 p-4 rounded-xl bg-white/[.10] border border-white/[.14]", children: [_jsx("audio", { ref: audioRef, src: src, preload: "metadata" }), _jsx("button", { onClick: toggle, className: "w-10 h-10 rounded-full bg-white text-black flex items-center justify-center shrink-0", children: playing ? _jsx(Pause, { className: "w-5 h-5" }) : _jsx(Play, { className: "w-5 h-5 ml-0.5" }) }), _jsx("div", { className: "flex-1 flex items-end gap-[2px] h-5", children: BARS.map((h, i) => {
                    const filled = i / BARS.length < progress;
                    return (_jsx("div", { className: "w-[3px] rounded-full", style: {
                            height: h,
                            background: filled ? 'rgba(236,72,153,.6)' : 'rgba(255,255,255,.5)',
                            transition: 'background .15s',
                        } }, i));
                }) }), durationLabel && _jsx("span", { className: "text-[12px] text-white/55 shrink-0", children: durationLabel })] }));
}
